import React from 'react';

import { flagStyles } from '../settings';

const SvgGA = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1776px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGA;
